import React from 'react'

import { TableFooter } from 'components'
import { EditIcon, DeleteIcon } from 'components/Icons'
//import { rows } from "pages/NGT/Syndicate/mock/static_data"
import { ISindicato, IGetFiltroResponse } from 'services/NGT/Syndicate'
import { FORMAT, SPACING } from 'utils'

import {
  TableContainerStyled,
  TableStyled,
  TableHeadStyled,
  TableRowStyled,
  TableCellStyled,
  TableBodyStyled
} from './TableActions.styles'

interface TableProps {
  listRow: IGetFiltroResponse[]
  pageNumber?: number
  setPageNumber: (_page: number) => void
  handleEditSyndicate: (syndicate: IGetFiltroResponse) => void
  handleDeleteSyndicate: (syndicateDelete: number) => void
}

export const TableActions = ({
  listRow,
  handleEditSyndicate,
  pageNumber,
  setPageNumber,
  handleDeleteSyndicate
}: TableProps) => {
  const [rowsPerPage, setRowsPerPage] = React.useState(15)

  const handleChangePage = (newPage: number) => setPageNumber(newPage)

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPageNumber(0)
  }

  return (
    <>
      <TableContainerStyled>
        <TableStyled stickyHeader>
          <TableHeadStyled>
            <TableRowStyled>
              <TableCellStyled align="left">
                Sindicato/Confederação
              </TableCellStyled>
              <TableCellStyled align="center">CNPJ Sindicato</TableCellStyled>
              <TableCellStyled align="center">Ações</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {(rowsPerPage > 0
              ? listRow?.slice(
                pageNumber * rowsPerPage,
                pageNumber * rowsPerPage + rowsPerPage
              )
              : listRow
            )?.map((row, index) => (
              <TableRowStyled
                key={`${row}-table-body`}
                evenNumber={index % 2 != 0}
              >
                <TableCellStyled align="left">
                  {row.nmSindicato}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {FORMAT.documento(row.cdCnpj)}
                </TableCellStyled>
                <TableCellStyled align='center'>
                  <EditIcon
                    cursor="pointer"
                    onClick={() => handleEditSyndicate(row)}
                    marginRight={SPACING.spacing15}
                  />
                  <DeleteIcon
                    cursor="pointer"
                    onClick={() => handleDeleteSyndicate(row.idSindicato)}
                  />
                </TableCellStyled>
              </TableRowStyled>
            ))}
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
      <TableFooter
        page={pageNumber}
        rows={listRow}
        rowsPerPage={rowsPerPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        typeFooter="offline"
      />
    </>
  )
}
